import { useEffect } from 'react';
import logger from 'lc-logger';
import appConfig from 'lc-app-config';
import LeftNavigation from '../components/leftNavigation/leftNavigation';
import WebsiteComponent from '../components/websiteComponent/websiteComponent';
import LandingPagesService from '../services/landing-pages';
import styles from '../styles/main.module.scss';
import XrayMode from '../components/xrayMode/xrayMode';
import trackHeapEvent from '../services/helpers/trackHeapEvent';
import csrf from '../services/helpers/csrf';
import {
  errorFilter,
  getUserHasLoggedIn,
  getOptimizelyUserExperiments,
  getUserLoggedInStatus,
} from '../services/helpers/common';

export default function Page({
  slug,
  leftNavigation,
  components,
  isPreview = false,
  spaceId,
  entryId,
  experiments,
  isExistingUser,
  isUserLoggedIn,
}) {
  useEffect(() => {
    trackHeapEvent(
      {
        Title: 'Page Load',
        Page: 'Website Home page',
      },
      `CMS_Unification`,
      experiments
    );
  }, [experiments]);

  return (
    <main className={styles.main}>
      <div className={leftNavigation ? styles.container : ''}>
        <div className={styles.landingPage}>
          {leftNavigation && (
            <div className={styles.leftNavigation}>
              <LeftNavigation slug={slug} {...leftNavigation} />
            </div>
          )}
          <div className={styles.components}>
            {components?.map((component, index) => {
              const key = `${component?.type}-${index}`;
              const title = component?.data?.title
                ? component?.data?.title
                : component?.data?.headline;

              return (
                <div key={key}>
                  {isPreview && spaceId && (
                    <XrayMode
                      title={title ?? 'Content'}
                      spaceId={spaceId}
                      entryId={entryId}
                    />
                  )}
                  <WebsiteComponent
                    {...component}
                    isExistingUser={isExistingUser}
                    isUserLoggedIn={isUserLoggedIn}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </main>
  );
}

export async function getServerSideProps(context) {
  const slug = '/';
  const isExistingUser = getUserHasLoggedIn(appConfig, context.req);
  const isUserLoggedIn = getUserLoggedInStatus(appConfig, context.req, slug);
  const userVariation = getOptimizelyUserExperiments(context.req.headers, slug);
  const landingPagesService = new LandingPagesService(context.preview);
  const props = await landingPagesService.getPageTemplateBySlug(
    slug,
    userVariation
  );
  if (!props) {
    logger.info(
      {
        statusCode: 404,
      },
      'LC-WEBSITE: Website home page not found'
    );
    return {
      notFound: true,
    };
  }
  logger.info(
    {
      statusCode: 200,
    },
    'LC-WEBSITE: Generating Website home page'
  );

  const spaceId = appConfig.get('CONTENTFUL_SPACE_ID');
  let csrfToken = '';
  try {
    csrfToken = await csrf(context.req, context.res);
  } catch (err) {
    logger.info(
      'LC-WEBSITE: Error in generating csrf in Website home page. Error: ',
      errorFilter(err)
    );
  }
  return {
    props: {
      ...props,
      isPreview: !!context.preview,
      spaceId,
      csrfToken,
      experiments: Object.fromEntries(userVariation),
      isExistingUser,
      isUserLoggedIn,
    },
  };
}
